var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from "vuex";
import Pagination from "../../common/components/Pagination";
import ReportStockService from "../../api/ReportStockService";
import CommonService from "../../api/CommonService";
import { UrlHelper } from "../../helper/UrlWrapper";
import { billDefaultDate } from "../../helper/defaultDate";
import QueryHeader from './components/QueryHeader';
import SummaryTable from './components/SummaryTable';
import { getTheDayZeroTime } from '../../helper/util';
import TableList from '../../components/common/TableList.vue';
function getDefaultFormData() {
    var data = {
        depot_ids: [],
        keyword: "",
        goods_type_id: null,
        s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: billDefaultDate().End.format('yyyy-MM-dd')
    };
    return data;
}
var QuerySummaryList = (function (_super) {
    __extends(QuerySummaryList, _super);
    function QuerySummaryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = ReportStockService.getInstance();
        _this.fetchAction = _this.service.getStockSummaryList;
        _this.filter = {};
        _this.formData = getDefaultFormData();
        _this.tableData = [];
        _this.tableHeight = document.documentElement.clientHeight - 210;
        _this.total = 0;
        _this.instructionsData = [
            {
                name: '期初',
                detail: '所选时间段开始时库存数据;'
            },
            {
                name: '入库',
                detail: '采购入库+调拨入库+报溢入库+退货入库+库存初始化入库'
            },
            {
                name: '出库',
                detail: '调拨出库+报损+送货+退货出库'
            },
            {
                name: '期末',
                detail: '期初+入库-出库'
            }
        ];
        return _this;
    }
    QuerySummaryList.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.initFilter();
    };
    QuerySummaryList.prototype.initFilter = function () {
        this.filter = {
            depot_ids: (this.formData.depot_ids || []).join(','),
            keyword: this.formData.keyword,
            goods_type_id: this.formData.goods_type_id ? this.formData.goods_type_id : -1,
            s_time: this.formData.s_time,
            e_time: this.formData.e_time,
        };
    };
    QuerySummaryList.prototype.multiColmunsSet = function (multiColmuns) {
        var resetMultiColmuns = multiColmuns.slice(0, 8).concat([
            {
                key: "stock_init",
                value: "期初",
                is_hidden: multiColmuns.slice(8, 13).find(function (item) { return !item.is_hidden; }) ? false : true,
                fixed: multiColmuns[8].fixed ? true : false,
                calcWidth: multiColmuns.slice(8, 13).filter(function (item) { return !item.is_hidden; }).length * 80,
                children: multiColmuns.slice(8, 13).slice()
            },
            {
                key: "warehouse",
                value: "入库",
                fixed: multiColmuns[13].fixed ? true : false,
                calcWidth: multiColmuns.slice(13, 32).filter(function (item) { return !item.is_hidden; }).length * 80,
                is_hidden: multiColmuns.slice(13, 32).find(function (item) { return !item.is_hidden; }) ? false : true,
                children: [
                    {
                        key: "warehouse_a",
                        value: "数量",
                        is_hidden: multiColmuns.slice(13, 18).find(function (item) { return !item.is_hidden; }) ? false : true,
                        children: multiColmuns.slice(13, 18).slice()
                    },
                    {
                        key: "warehouse_b",
                        value: "金额",
                        is_hidden: multiColmuns.slice(18, 28).find(function (item) { return !item.is_hidden; }) ? false : true,
                        children: [
                            {
                                key: "warehouse_b_1",
                                value: "采购入库",
                                is_hidden: multiColmuns.slice(18, 20).find(function (item) { return !item.is_hidden; }) ? false : true,
                                children: multiColmuns.slice(18, 20).slice()
                            },
                            {
                                key: "warehouse_b_2",
                                value: "调拨入库",
                                is_hidden: multiColmuns.slice(20, 22).find(function (item) { return !item.is_hidden; }) ? false : true,
                                children: multiColmuns.slice(20, 22).slice()
                            },
                            {
                                key: "warehouse_b_3",
                                value: "报溢入库",
                                is_hidden: multiColmuns.slice(22, 24).find(function (item) { return !item.is_hidden; }) ? false : true,
                                children: multiColmuns.slice(22, 24).slice()
                            },
                            {
                                key: "warehouse_b_4",
                                value: "退货入库",
                                is_hidden: multiColmuns.slice(24, 26).find(function (item) { return !item.is_hidden; }) ? false : true,
                                children: multiColmuns.slice(24, 26).slice()
                            },
                            {
                                key: "warehouse_b_5",
                                value: "库存初始化入库",
                                is_hidden: multiColmuns.slice(26, 28).find(function (item) { return !item.is_hidden; }) ? false : true,
                                children: multiColmuns.slice(26, 28).slice()
                            },
                        ]
                    },
                    {
                        key: "warehouse_c",
                        value: "入库合计",
                        is_hidden: multiColmuns.slice(18, 32).find(function (item) { return !item.is_hidden; }) ? false : true,
                        children: multiColmuns.slice(28, 32).slice()
                    },
                ]
            },
            {
                key: "delivery",
                value: "出库",
                fixed: multiColmuns[32].fixed ? true : false,
                calcWidth: multiColmuns.slice(32, 48).filter(function (item) { return !item.is_hidden; }).length * 80,
                is_hidden: multiColmuns.slice(32, 48).find(function (item) { return !item.is_hidden; }) ? false : true,
                children: [
                    {
                        key: "delivery_a",
                        value: "数量",
                        is_hidden: multiColmuns.slice(32, 36).find(function (item) { return !item.is_hidden; }) ? false : true,
                        children: multiColmuns.slice(32, 36).slice()
                    },
                    {
                        key: "delivery_b",
                        value: "金额",
                        is_hidden: multiColmuns.slice(36, 44).find(function (item) { return !item.is_hidden; }) ? false : true,
                        children: [
                            {
                                key: "delivery_b_1",
                                value: "送货出库",
                                is_hidden: multiColmuns.slice(36, 38).find(function (item) { return !item.is_hidden; }) ? false : true,
                                children: multiColmuns.slice(36, 38).slice()
                            },
                            {
                                key: "delivery_b_2",
                                value: "调拨出库",
                                is_hidden: multiColmuns.slice(38, 40).find(function (item) { return !item.is_hidden; }) ? false : true,
                                children: multiColmuns.slice(38, 40).slice()
                            },
                            {
                                key: "delivery_b_3",
                                value: "报损出库",
                                is_hidden: multiColmuns.slice(40, 42).find(function (item) { return !item.is_hidden; }) ? false : true,
                                children: multiColmuns.slice(40, 42).slice()
                            },
                            {
                                key: "delivery_b_4",
                                value: "退货出库",
                                is_hidden: multiColmuns.slice(42, 44).find(function (item) { return !item.is_hidden; }) ? false : true,
                                children: multiColmuns.slice(42, 44).slice()
                            },
                        ]
                    },
                    {
                        key: "delivery_c",
                        value: "出库合计",
                        is_hidden: multiColmuns.slice(44, 48).find(function (item) { return !item.is_hidden; }) ? false : true,
                        children: multiColmuns.slice(44, 48).slice()
                    },
                ]
            },
            {
                key: "total",
                value: "期末统计",
                fixed: multiColmuns[48].fixed ? true : false,
                calcWidth: multiColmuns.slice(48, 53).filter(function (item) { return !item.is_hidden; }).length * 80,
                is_hidden: multiColmuns.slice(48, 53).find(function (item) { return !item.is_hidden; }) ? false : true,
                children: multiColmuns.slice(48, 53).slice()
            },
        ]);
        return resetMultiColmuns;
    };
    QuerySummaryList.prototype.searchClick = function () {
        var _this = this;
        var timeDiff = getTheDayZeroTime(new Date(this.formData.e_time)) - getTheDayZeroTime(new Date(this.formData.s_time));
        if (timeDiff < 0 || timeDiff > 365 * 1000 * 24 * 60 * 60) {
            this.$message.warning("最大查询范围不可超过一年");
            return;
        }
        this.initFilter();
        this.$nextTick(function () {
            _this.$refs.TableList.fetch();
        });
    };
    QuerySummaryList.prototype.reset = function () {
        this.formData = getDefaultFormData();
    };
    QuerySummaryList.prototype.exportData = function () {
        var url = "supplierclientapi/report/export_stock_summary?";
        url = UrlHelper.addParam(url, 'depot_ids', (this.formData.depot_ids || []).join(','));
        url = UrlHelper.addParam(url, 'keyword', this.formData.keyword);
        url = UrlHelper.addParam(url, 'goods_type_id', this.formData.goods_type_id ? this.formData.goods_type_id : -1);
        url = UrlHelper.addParam(url, 's_time', this.formData.s_time);
        url = UrlHelper.addParam(url, 'e_time', this.formData.e_time);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(["_trackEvent", '出入库汇总列表', '出入库汇总导出']);
    };
    QuerySummaryList = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            components: {
                'pagination': Pagination,
                'query-header': QueryHeader,
                'list-table': SummaryTable,
                TableList: TableList
            }
        })
    ], QuerySummaryList);
    return QuerySummaryList;
}(Vue));
export default QuerySummaryList;
